import { useEffect } from "react";
import { isEuRegion } from "../../auth/region";
import { isDev } from "../getRegions/regionActions";

const SCRIPT_SRC = "https://www.datadoghq-browser-agent.com/datadog-rum-v4.js";

let initialized = false;
let loading = false;

function getDiscoveryUrl() {
   const url = !isDev && !window.location.hostname.includes("localhost") ? "https://auth.api.playbackhealth.com/" : "https://auth-dev.playback-dev.com/"
   const authBase = (url).replace(/\/$/, "");
   if (!authBase) return null;
   const region = isEuRegion ? "eu" : "us";
   return `${authBase}/discovery?region=${region}`;
}

async function fetchDatadogWebConfig() {
   const discoveryUrl = getDiscoveryUrl();
   if (!discoveryUrl) return null;

   const response = await fetch(discoveryUrl, {
      method: "GET",
      headers: { Accept: "application/json" },
   });
   if (!response.ok) return null;

   const data = await response.json();
   const web = data?.datadog?.web;
   if (!web?.appId || !web?.clientToken) return null;

   return {
      applicationId: web.appId,
      clientToken: web.clientToken,
      env: web.environment || (process.env.NODE_ENV === "production" ? "prod" : "dev"),
   };
}

function injectAndInit({ applicationId, clientToken, env }) {
   const init = () => {
      if (!window.DD_RUM || initialized) return;
      window.DD_RUM.init({
         applicationId,
         clientToken,
         site: "datadoghq.com",
         service: "providerweb",
         env,
         sampleRate: 100,
         trackInteractions: true,
      });
      initialized = true;
   };

   const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
   if (existing) {
      init();
      return;
   }

   const script = document.createElement("script");
   script.src = SCRIPT_SRC;
   script.crossOrigin = "anonymous";
   script.onload = init;
   document.head.appendChild(script);
}

export async function loadDatadogRum() {
   if (initialized || loading) return;

   loading = true;
   try {
      const config = await fetchDatadogWebConfig();
      if (!config) return;
      injectAndInit(config);
   } catch (err) {
      // Discovery or script load failure should not break the app.
      console.warn("Datadog RUM init skipped:", err);
   } finally {
      loading = false;
   }
}

export default function DatadogRum() {
   useEffect(() => {
      loadDatadogRum();
   }, []);
   return null;
}
